import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";


export const login = ({commit, dispatch}, payload) => {

    axios.post('/login/index.php', payload)
    .then(res => {

        if(res.data.status) {
            dispatch('storeAuthResponse', {data: res.data, goHome: true})
            
         } else {
            commit('setAlertBox', {title: 'Error', message: 'Login Failed'})
         }

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const fetchReminders = ({commit}) => {

    axios.get('/reminders/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setReminderList', res.data.response)
    })
    .catch(error => {
        console.log(error)
    })
    
}

export const fetchDashboardSalesGraphs = ({commit}, payload) => {

    axios.post('/dashboard/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        //console.log(JSON.stringify(res.data))
        commit('setDashboardValues', res.data.response)

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const changePassword = ({commit, dispatch}, payload) => {

    axios.post('/login/changePassword.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            dispatch('logout')
        } else {
            commit('setAlertBox', {title: 'Error', message: res.data.message})    
        }
        

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const masterLogin = ({dispatch}, payload) => {

    axios.post('/login/masterLogin.php', payload)
    .then(res => {
        
        if(res.data.status) {
            dispatch('storeAuthResponse', {data: res.data, goHome: true})            
         } else {
            alert('Login failed')
         }

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const storeAuthResponse = ({commit, dispatch}, payload) => {

    let accessToken = payload.data.access_token
    let expirationTime = payload.data.expiration_time

    let date = new Date(expirationTime);
    expirationTime = date.getTime() / 1000;
    
    localStorage.setItem('accessToken', accessToken)
    
    if(payload.data.modules != 'ALL') {
        payload.data.modules = JSON.parse(payload.data.modules)
    }
    
    if(payload.goHome) {
        dispatch('goToHomePage', { menus: payload.data.modules, homePage: true, checkRequired: false })
    }
    
    commit('setUserauthResponse', payload.data)

}

export const goToHomePage = ({commit}, payload) => {
    
    window.location = '/'
    /*
    if(payload.menus == 'ALL') {
        if(payload.homePage) {
            window.location = '/'
        }
    } else {
    
        let pathFound = false
        let path = ""
        payload.menus.forEach(element => {
            if(!pathFound) {
                if(element.access.canView) {
                    element.subMenus.forEach(element1 => {
                    if(element1.access.canView) {
                        if(!pathFound) {
                            pathFound = true
                            path = element1.path
                        }
                    }
                    })
                }
            }
        })
        if(payload.homePage && pathFound) {
            window.location = path
        }
        
    }*/
    
}

export const setLogoutTimer = ({dispatch}, payload) => {

    console.log(new Date().getTime()/1000)
    console.log(payload)

}


export const approveAction = ({commit, dispatch}, payload) => {

    axios.post('/login/approveAction.php', 
        {email: payload.email, password: payload.password, admin: payload.carryForwardParams.admin}, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            dispatch(payload.carryForwardParams.target, payload.carryForwardParams.targetParameters)
            setTimeout(() => {
                commit('setAuthDialogOff')    
            }, 1000);
            
         } else {
            alert('Login failed')
         }

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const forgotpassword = ({commit, dispatch}, payload) => {

    axios.post('/login/forgotPassword.php', payload)
    .then(res => {
        
        
    })
    .catch(error => {
        console.log(error)
    })
    
}

export const tryAutoLogin = ({commit, dispatch}) => {

    const accessToken = localStorage.getItem('accessToken')
    
    if(!accessToken) {
        return 
    }
    
    const postData = {access_token: accessToken}
    
    axios.post('/login/autoLogin.php', postData)
    .then(res => {
        if(res.data.status) {
            dispatch('storeAuthResponse', {data: res.data, goHome: false})
        } else {
            dispatch('logout')
        }

    })
    .catch(error => {
       
    })
    
}

export const logout = ({commit}) => {

    
    axios.get('/login/logout.php', accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('clearAuthData')
        localStorage.removeItem('accessToken')
        window.location = '/login'
        
    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'Error', message: 'Error: ¡Inténtalo de nuevo!'})                
    })
    
}

export const postActivityLog = ({commit}, payload) => {

    
    axios.post('/activityLogs/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        //console.log(JSON.stringify(res.data))
        
    })
    .catch(error => {
        console.log(error)
commit('setAlertBox', {title: 'Error', message: 'Error: ¡Inténtalo de nuevo!'})                
    })
    
}

export const signup = ({commit, dispatch}, payload) => {

    axios.post('/signup/index.php', payload)
    .then(res => {

        if(res.data.status) {
            commit('setAlertBox', {title: 'message.information', message: res.data.message})    
            commit('toggleLoginStatus')
        } else {
            commit('setAlertBox', {title: 'Error', message: res.data.message})    
        }

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const confirmEmailAddress = ({commit, dispatch}, payload) => {

    axios.post('/signup/confirmEmailAddress.php', {code: payload})
    .then(res => {

        dispatch('storeAuthResponse', {data: res.data, goHome: true})

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const fetchDasboardProps = ({commit}, payload) => {

    axios.post('/dashboard/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        console.log(JSON.stringify(res.data))
       // commit('setDashboardProps', res.data)
        
    })
    .catch(error => {
        commit('setAlert', {message: 'message.errorTryAgain'})    
    })

}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js